import Confirm from './scripts';
import './styles/confirm.scss';

Confirm.init();
